import React from 'react';
import { Box } from '@mui/material';
import { DndProvider } from 'react-dnd';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { HTML5Backend } from 'react-dnd-html5-backend';

import { BoardColumn } from './BoardColumn';
import { BoardProps } from './types';

export function Board<T>({ columns, renderCard, renderColumnHeader, onMoveCard, canDropColumn }: BoardProps<T>) {
  const classes = useStyles({ columnsAmount: columns.length });

  return (
    <DndProvider backend={HTML5Backend}>
      <Box className={classes.board}>
        {columns.map(({ id, ...other }) => (
          <BoardColumn<T>
            id={id}
            key={id}
            {...other}
            renderCard={renderCard}
            onMoveCard={onMoveCard}
            canDropColumn={canDropColumn}
            renderColumnHeader={renderColumnHeader}
          />
        ))}
      </Box>
    </DndProvider>
  );
}

const useStyles = makeStyles<Theme, { columnsAmount: number }>({
  board: {
    gap: '0.5rem',
    height: '100%',
    display: 'flex',
    overflow: 'auto',
  },
});
